import Config from '@config';
import { initializeSessionsApi } from '@gasbi/shared/common/features/sessions';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  sessionsApi,
  useGetUserSessionsInfiniteQuery,
  useRevokeSessionMutation,
  useRevokeAllUserSessionsMutation,
} = initializeSessionsApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});
